import { Navigate, useParams } from "react-router";

// Settings became a tab of the store page (2026-09-27); the old URL keeps working.
export const StoreSettingsRedirect = () => {
  const { storeId } = useParams<{ storeId: string }>();
  return <Navigate to={storeId ? `/stores/${storeId}?tab=settings` : "/stores"} replace />;
};
